import * as React from 'react';
import LoginErrorMessagesComponent from 'src/modules/modals/login/partials/LoginErrorMessages.component';
import '../Modals.css';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';

export interface LoginComponentProps {
  handleChange: (key: string) => ((value: string | boolean) => void);
  handleSubmit: () => void;
  register: () => void;
  passwordRecovery: () => void;
  rememberMe: boolean;
  error: boolean;
  errorMessage: {};
  modalRef?: Modal;
}

const LoginComponent: React.StatelessComponent<LoginComponentProps> = (props: LoginComponentProps) => (
  <div className="modal-content">
    <div className="modal-header">
      <p className="text-right">
        <span
          className="close-med pointer"
          onClick={() => props.modalRef!.modal('hide')}
        />
      </p>
      <img
        src="/img/the-crowd-angel.png"
        alt="logo"
      />
      <div className="gap-20" />
      <hr />
    </div>
    <div className="modal-body">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          props.handleSubmit();
        }}
      >
        <h3 className="deco-title c-black-text">
          Iniciar sesión
        </h3>
        <div className="gap-20" />
        <div className="md-input">
          <input
            className="md-form-control"
            required={true}
            type="text"
            onChange={(e) => props.handleChange('email')(e.target.value)}
          />
          <span className="highlight" />
          <span className="bar" />
          <label>
            Email *
          </label>
        </div>
        <div className="md-input">
          <input
            className="md-form-control"
            required={true}
            type="password"
            onChange={(e) => props.handleChange('password')(e.target.value)}
          />
          <span className="highlight" />
          <span className="bar" />
          <label>
            Contraseña *
          </label>
        </div>
        <div className="gap-20" />
        <div className="checkbox">
          <input
            type="checkbox"
            defaultChecked={props.rememberMe}
          />
          <label onClick={(e) => props.handleChange('rememberMe')(!props.rememberMe)}>
            Recordarme en este equipo
          </label>
        </div>
        <div className="gap-20" />
        <button
          type="submit"
          className="btn btn-primary"
        >
          Iniciar sesión
        </button>
        <div className="gap-10" />
        <p
          className="pointer"
          onClick={() => props.passwordRecovery()}
        >
          <i>¿Olvidaste tu contraseña?</i> 
        </p>
        <div className="gap-20" />
        <LoginErrorMessagesComponent
          error={props.error}
          errorMessage={props.errorMessage}
          register={props.register}
        />
      </form>
    </div>
    <div className="modal-footer">
      <div className="gap-10" />
      <p className="text-center">
        ¿Aún no estás registrado?&nbsp;
        <a
          className="pointer"
          onClick={() => props.register()}
        >
          Regístrate
          <span className="arrow-right-primary-dark" />
        </a>
      </p>
    </div>
  </div>
);

export default LoginComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/login/Login.component.tsx